// The University of Missouri's undergraduate majors (#2840). Read on
// 2026-10-01 from the official Academic Catalog's "Degrees, Majors (Degree
// Programs), Emphasis Areas, Minors and Certificates" table
// (catalog.missouri.edu/degreesanddegreeprograms), which gives each program,
// its college and its undergraduate, graduate and professional awards.
// Every bachelor's award in the Undergraduate column is kept (a program
// with two bachelor's degrees, such as Art BA and BFA, is listed twice);
// minors, certificates and graduate or professional degrees are left out.
// Emphasis areas in parentheses are dropped from the names, except that the
// "Interdisciplinary" BA carries its emphases as a note. College names come
// from the catalog's own abbreviation table; degree abbreviations are the
// catalog's (BSAcc, BSBA, BHS, BSEd, BJ, ...), with its emphasis
// superscripts removed. The catalog lists both Psychological Sciences
// (BA, BS) and Psychology (BA) under Arts and Science; both are kept as
// listed. The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-missouri",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in the University of Missouri's Academic Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture, Food and Natural Resources",
            "source": {
                "label": "University of Missouri Academic Catalog, Degrees, Majors (Degree Programs), Emphasis Areas, Minors and Certificates",
                "url": "https://catalog.missouri.edu/degreesanddegreeprograms/"
            },
            "majors": [
                {
                    "name": "Agribusiness Management",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Leadership, Communications and Education",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Systems Technology",
                    "degree": "BS"
                },
                {
                    "name": "Agriculture",
                    "degree": "BS"
                },
                {
                    "name": "Animal Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Food Science and Human Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "BS"
                },
                {
                    "name": "Natural Resource Science and Management",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Exercise Physiology",
                    "degree": "BS"
                },
                {
                    "name": "Parks, Recreation, Sport and Tourism",
                    "degree": "BS"
                },
                {
                    "name": "Personal Financial Planning",
                    "degree": "BS"
                },
                {
                    "name": "Plant Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Arts and Science",
            "source": {
                "label": "University of Missouri Academic Catalog, Degrees, Majors (Degree Programs), Emphasis Areas, Minors and Certificates",
                "url": "https://catalog.missouri.edu/degreesanddegreeprograms/"
            },
            "majors": [
                {
                    "name": "Ancient Mediterranean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Architectural Studies",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Constitutional Democracy",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Digital Storytelling",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Film Studies",
                    "degree": "BA"
                },
                {
                    "name": "General Studies",
                    "degree": "BGS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Health Humanities",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary",
                    "degree": "BA",
                    "note": "Emphasis areas: Black Studies, Peace Studies, Women's and Gender Studies."
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Psychological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Administration and Policy",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Romance Languages",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Textile and Apparel Management",
                    "degree": "BS"
                },
                {
                    "name": "Theatre and Performance Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Trulaske College of Business",
            "source": {
                "label": "University of Missouri Academic Catalog, Degrees, Majors (Degree Programs), Emphasis Areas, Minors and Certificates",
                "url": "https://catalog.missouri.edu/degreesanddegreeprograms/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BSAcc"
                },
                {
                    "name": "Business Administration",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "University of Missouri Academic Catalog, Degrees, Majors (Degree Programs), Emphasis Areas, Minors and Certificates",
                "url": "https://catalog.missouri.edu/degreesanddegreeprograms/"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Educational Studies",
                    "degree": "BES"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BS"
                },
                {
                    "name": "Middle School Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BSEd"
                },
                {
                    "name": "Special Education",
                    "degree": "BSEd"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "University of Missouri Academic Catalog, Degrees, Majors (Degree Programs), Emphasis Areas, Minors and Certificates",
                "url": "https://catalog.missouri.edu/degreesanddegreeprograms/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biological Engineering",
                    "degree": "BSBE"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCiE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSCoE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Construction Management",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE"
                },
                {
                    "name": "Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BSIE"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "College of Health Sciences",
            "source": {
                "label": "University of Missouri Academic Catalog, Degrees, Majors (Degree Programs), Emphasis Areas, Minors and Certificates",
                "url": "https://catalog.missouri.edu/degreesanddegreeprograms/"
            },
            "majors": [
                {
                    "name": "Clinical and Diagnostic Sciences",
                    "degree": "BHS"
                },
                {
                    "name": "Criminal & Justice Studies",
                    "degree": "BS"
                },
                {
                    "name": "Health Science",
                    "degree": "BHS"
                },
                {
                    "name": "Occupational Therapy Assistant",
                    "degree": "BHS"
                },
                {
                    "name": "Pre-Professional Physical Therapy",
                    "degree": "BHS"
                },
                {
                    "name": "Public Health",
                    "degree": "BHS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Speech, Language and Hearing Sciences",
                    "degree": "BHS"
                },
                {
                    "name": "Sport Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Journalism",
            "source": {
                "label": "University of Missouri Academic Catalog, Degrees, Majors (Degree Programs), Emphasis Areas, Minors and Certificates",
                "url": "https://catalog.missouri.edu/degreesanddegreeprograms/"
            },
            "majors": [
                {
                    "name": "Journalism",
                    "degree": "BJ"
                }
            ]
        },
        {
            "name": "Sinclair School of Nursing",
            "source": {
                "label": "University of Missouri Academic Catalog, Degrees, Majors (Degree Programs), Emphasis Areas, Minors and Certificates",
                "url": "https://catalog.missouri.edu/degreesanddegreeprograms/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "College of Veterinary Medicine",
            "source": {
                "label": "University of Missouri Academic Catalog, Degrees, Majors (Degree Programs), Emphasis Areas, Minors and Certificates",
                "url": "https://catalog.missouri.edu/degreesanddegreeprograms/"
            },
            "majors": [
                {
                    "name": "Veterinary Technology",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
